/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
   
  countTotalCurrentFilters(obj: Record<string, any>): number {
    let count = 0;

    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
        count++;
      }
    }

    return count;
  }

  timeRangeValidator: ValidatorFn = (control: AbstractControl): Record<string, any> | null => {
    const horaInicio = control.get('horaInicio');
    const horaFin = control.get('horaFin');

    if (!horaInicio?.value || !horaFin?.value) {
      return null;
    }

    const [inicioHours, inicioMinutes] = horaInicio.value.split(':').map(Number);
    const [finHours, finMinutes] = horaFin.value.split(':').map(Number);
    const inicioTime = inicioHours * 60 + inicioMinutes;
    const finTime = finHours * 60 + finMinutes;

    return finTime >= inicioTime ? null : { invalidTimeRange: true };
  };
}
